import React from "react";
import styles from "./Achievements.module.css";

const achievements = [
  { title: "AI-Native Builder", subtitle: "Claude Code, Codex, OpenClaw power user" },
  { title: "10+ Products Shipped", subtitle: "Full stack & AI agent systems" },
  { title: "Agent Orchestration", subtitle: "Multi-agent workflows & autonomous systems" },
  { title: "Full Stack Developer", subtitle: "Masai School" },
];

function Achievements() {
  return (
    <section className={styles.section} style={{ opacity: 0, animation: "fadeIn 0.6s ease-out 0.45s forwards" }}>
      <h2 className={styles.heading}>Achievements</h2>
      <div className={styles.list}>
        <ul className={styles.ul}>
          {achievements.map((item, i) => (
            <li key={i} className={styles.item}>
              <span className={styles.titleWrap}>
                <span className={styles.title}>{item.title}</span>
              </span>
              <span className={styles.subtitle}>{item.subtitle}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Achievements;
